export const MODAL_DIALOG__LOGIN = 'MODAL_DIALOG__LOGIN';
export const MODAL_DIALOG__REGISTRATION = 'MODAL_DIALOG__REGISTRATION';
export const MODAL_DIALOG__SOCIAL_REGISTRATION = 'MODAL_DIALOG__SOCIAL_REGISTRATION';
